import LocalStorageConstants from "../constants/LocalStorageConstants";

class LocalStorageUtil {
	static saveData(key, value) {
		localStorage.setItem(key, JSON.stringify(value));
	}

	static getData(key) {
		try {
			return localStorage.getItem(key);
		} catch (error) {
			// No need to alert bugsnag. Some browsers in private mode do not have access to localstorage and so exceptions are expected
			return null;
		}
	}

	static loadAdParams() {
		const data = localStorage.getItem("ad");;
		return data ? JSON.parse(data) : null;
	}

	static saveFbclid(id) {
		this.saveData(LocalStorageConstants.FB_FBCLID, id?.toString());
	}

	static loadFbclid() {
		const data = this.getData(LocalStorageConstants.FB_FBCLID);
		return data ? JSON.parse(data) : null;
	}

	static saveEntryTimestamp() {
		const now = new Date();
		this.saveData(LocalStorageConstants.FB_ENTRY_TIMESTAMP, now.getTime().toString());
	}

	static loadEntryTimestamp() {
		const data = this.getData(LocalStorageConstants.FB_ENTRY_TIMESTAMP);
		return data ? JSON.parse(data) : null;
	}

	static loadAnonymousUserId() {
		const data = this.getData(LocalStorageConstants.ANONYMOUS_USER_ID);
		return data ? JSON.parse(data) : null;
	}

	static saveAnonymousUserId(id) {
		this.saveData(LocalStorageConstants.ANONYMOUS_USER_ID, id?.toString());
	}

	static savePageVisited(eventName) {
		this.saveData(`${LocalStorageConstants.LAST_PAGE_VISITED}-${eventName}`, new Date().getTime());
	}

	static loadPageVisited(eventName) {
		const data = this.getData(`${LocalStorageConstants.LAST_PAGE_VISITED}-${eventName}`);
		return data ? JSON.parse(data) : null;
	}
	
}

export default LocalStorageUtil;
